import React from "react";

const CORES = {
  ativo: "bg-emerald-500/15 text-emerald-600 dark:text-emerald-400", ativa: "bg-emerald-500/15 text-emerald-600 dark:text-emerald-400",
  agendado: "bg-sky-500/15 text-sky-600 dark:text-sky-400", agendada: "bg-sky-500/15 text-sky-600 dark:text-sky-400",
  expirado: "bg-muted text-muted-foreground", encerrada: "bg-muted text-muted-foreground",
  esgotado: "bg-amber-500/15 text-amber-600 dark:text-amber-400", esgotada: "bg-amber-500/15 text-amber-600 dark:text-amber-400",
  desativado: "bg-muted text-muted-foreground", desativada: "bg-muted text-muted-foreground",
  excluido: "bg-red-500/10 text-red-500", excluida: "bg-red-500/10 text-red-500", desconhecida: "bg-red-500/10 text-red-500",
};

export default function Selo({ status, rotulo, className = "" }) {
  return (
    <span className={`inline-flex items-center whitespace-nowrap text-[10px] font-bold uppercase tracking-wide px-2 py-0.5 rounded-full ${CORES[status] || "bg-muted text-muted-foreground"} ${className}`}>
      {rotulo || status}
    </span>
  );
}
